import { App } from './App';

class FlowGuid {
    constructor() {
        this._guideFlowForm = '';
        this._targetUrl = '';
        this._preNextCallBackOk = true;
        this._preNextCallBackCount = 0;
        this._preNextExecuteFormStarted = false;
        this._guideFlowFormSettings = {};
        // init auto postback functionalitet
        this._guideFlowForm = document.querySelector('form.jsGuideFlowForm');

        // is Auto-flow-post form "jsGuideFlowForm"
        if (this._guideFlowForm) {
            const s = this._guideFlowForm.dataset.guideflowsetting;
            this.InitGuideFlowFormSettings(s);
            window.onPageLeaveExecute = window.onPageLeaveExecute || new Array();
            window.onPageLeaveExecute.push(this.PostGuideFlowForm);
        }
    }

    PreNextCallBack(step, ok, response, sender) {
        const itSelf = App.flowGuide;
        itSelf._preNextCallBackCount--;

        if (!ok) itSelf._preNextCallBackOk = false;
        if (itSelf._preNextCallBackCount < 1) {
            if (itSelf._preNextCallBackOk) {
                window.location.href = itSelf._targetUrl;
                return;
            }
            itSelf.SpinnerDisabler();
        }
    }

    // called from pre/next buttons
    preNextExecuteForm(step, url) {
        const itSelf = App.flowGuide;
        itSelf._targetUrl = url;

        var infobox = document.getElementById('guidePreNextErrInfoBox');
        infobox.classList.add('hide');

        itSelf.SpinnerEnabler(step);

        var o = window.onPageLeaveExecute;
        if (!o || typeof o == 'undefined' || o.length < 1) {
            itSelf.PreNextCallBack(step, true, {}, 'PreNextExecuteForm no onPageLeaveExecute');
            return;
        }
        itSelf._preNextCallBackCount = o.length;
        itSelf._preNextCallBackOk = true;
        o.forEach(function (f) { f(step, itSelf.PreNextCallBack); });
    }

    // Auto-flow-post - post form (called from PostGuideFlowForm)
    PostFormData(data, url, okCallback, errorCallback) {
        fetch(url, {
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: data
        }).then(response => response.json()).then(json => {
            if (json.ok) {
                okCallback('ok', json);
            } else {
                errorCallback(json.message, json);
            }
        }).catch(error => {
            errorCallback(error.Message);
            return;
        });
    }

    SpinnerEnabler(step) {
        const aa = step == 1 ? 'is-loading' : 'fade';
        const bb = step == -1 ? 'is-loading' : 'fade';
        const a = document.getElementById('guide-next-button');
        if (a) a.classList.add(aa);
        const b = document.getElementById('guide-prev-button');
        if (b) b.classList.add(bb);
    }

    SpinnerDisabler(step) {
        const a = document.getElementById('guide-next-button');
        if (a) {
            a.classList.remove('is-loading');
            a.classList.remove('fade');
        }
        const b = document.getElementById('guide-prev-button');
        if (b) {
            b.classList.remove('is-loading');
            b.classList.remove('fade');
        }
    }

    // Auto-flow-post execute on next/pre and executes prePostScript and PostFormData (if existes)
    PostGuideFlowForm(step, callback) {
        const itSelf = App.flowGuide;
        const url = itSelf._guideFlowFormSettings.url;

        if (step == -1 && itSelf._guideFlowFormSettings.doPostOnPrev == false) {
            App.flowGuide.PostGuideFlowFormCallback(callback, -1, true, 'ok');
            return;
        }

        if (itSelf._guideFlowFormSettings.prePostScript) {
            const r = eval(itSelf._guideFlowFormSettings.prePostScript); // eslint-disable-line
            if (!r) {
                callback(step, false, '', 'PostGuideFlowForm !r');
                return;
            }
        }

        var data = $(itSelf._guideFlowForm).serialize();
        itSelf.PostFormData(data, url, (t) => App.flowGuide.PostGuideFlowFormCallback(callback, step, true, 'ok'), (t) => App.flowGuide.PostGuideFlowFormCallback(callback, step, false, t));
    }

    // Auto-flow-post post back function. Called from PostFormData
    PostGuideFlowFormCallback(callback, step, ok, msg, json) {
        if (!ok) {
            var infobox = document.getElementById('guidePreNextErrInfoBox');
            var infoboxText = document.getElementById('guidePreNextErrText');
            infoboxText.innerText = msg || '';
            infobox.classList.remove('hide');
        }
        callback(step, ok, msg);
    }

    InitGuideFlowFormSettings(stringJson) {
        const j = JSON.parse(stringJson);
        const t = this._guideFlowFormSettings;

        t.url = j.url || '';
        t.prePostScript = j.prePostScript || '';
        t.doPostOnPrev = j.doPostOnPrev || false;
    }
}

App.flowGuide = new FlowGuid();
